"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var uuid = require('uuid');

var SoulModule = require('./SoulModule');
/**
* Monetize your app
* @extends SoulModule
*/


var Purchases =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Purchases, _SoulModule);

  function Purchases() {
    _classCallCheck(this, Purchases);

    return _possibleConstructorReturn(this, _getPrototypeOf(Purchases).apply(this, arguments));
  }

  _createClass(Purchases, [{
    key: "getUserAccess",

    /**
     * Get user payment status
     * @return {Promise}
     * @soulsdk soul.purchases.getUserAccess()
     * @example soul.purchases.getUserAccess()
     */
    value: function getUserAccess() {
      return this.api.get('purchases/has_access');
    }
    /**
    * Get list of bundles that user can buy
    * @return {Promise}
    * @soulsdk soul.purchases.getAvailableProducts
    * @example soul.purchases.getAvailableProducts()
    */

  }, {
    key: "getAvailableProducts",
    value: function getAvailableProducts() {
      return this.api.get('purchases/all');
    }
    /**
     * Get list of bundles that user bought, and items in user inventory
     * @return {Promise}
     * @soulsdk soul.purchases.getOwnedProducts
     * @example soul.purchases.getOwnedProducts()
     */

  }, {
    key: "getOwnedProducts",
    value: function getOwnedProducts() {
      return this.api.get('purchases/my');
    } // TODO This request will removed, need to use `purchases/my`

  }, {
    key: "getSubscriptions",
    value: function getSubscriptions() {
      return this.api.get('purchases/my-subscriptions');
    }
    /**
    * Use item from user inventory
    * @param {object} purchase
    * @return {Promise}
    * @soulsdk soul.purchases.consumeProduct
    * @example
    * soul.purchases.consumeProduct({
    *   "itemId": 123,
    *   "quantity": 1,
    * }).then(successCallback).catch(errorCallback)
    */

  }, {
    key: "consumeProduct",
    value: function consumeProduct(product) {
      return this.api.post('purchases/consume', product);
    }
    /**
    * Submits an AppStore purchase receipt for validation
    * @param {Object} params
    * @param {string} params.receipt
    * @return {Promise}
    * @soulsdk soul.purchases.appStoreValidation
    * @example soul.purchases.appStoreValidation({
    *   receipt: 'ewpfkwepoj{)Jofj90woefhjnwepf9hjwe9f[0jwef90whj3[409fgh4woghw40p9gh39ifjo34pfj34igl'
    * })
    *
    */

  }, {
    key: "appStoreValidation",
    value: function appStoreValidation(_ref) {
      var receipt = _ref.receipt;
      return this.api.post('purchases/order/appstore', {
        receipt: receipt
      });
    }
    /**
    * Submits a Google Play purchase token for validation
    * @param {Object} params
    * @param {string} params.token
    * @param {string} params.subscriptionId
    * @param {string} params.signature
    * @return {Promise}
    * @soulsdk soul.purchases.googlePlayValidation
    * @example soul.purchases.googlePlayValidation({
    *   'token': 'wjkweo0fjwpefh9wep890h*(Hw9ehjf09wehf9weh0fwef',
    *   'subscriptionId': 'com.soul.someProduct',
    *   'signature': 'wekfpwej0f9[3jf23pfh32jf0p32kf32'
    * })
    */

  }, {
    key: "googlePlayValidation",
    value: function googlePlayValidation(_ref2) {
      var token = _ref2.token,
          subscriptionId = _ref2.subscriptionId,
          signature = _ref2.signature;
      return this.api.post('purchases/order/googleplay', {
        token: token,
        subscriptionId: subscriptionId,
        signature: signature
      });
    }
    /**
     * Returns cardbilling payment URL.
     * @param {Object} params
     * @param {string} params.bundleName
     * @param {string} [params.email]
     * @param {string} [params.backUrl] Url to redirect after payment
     * @param {string} [params.rejectUrl] Url to redirect after payment failure
     * @param {string} [params.paymentSystem='cardpay'] name of payment system.
     * @param {string} [params.campaign='who_did_not_buy'] name of campaign.
     * @param {string} [params.sentType='manual'] type of campaign.
     * @param {string} [params.daysFromExpiredOffer='0'] days
     * @param {string} [params.mjTemplateId='123456'] template id
     * @return {Promise}
     * @soulsdk soul.purchases.getPaymentUrlForBundle
     * @example soul.purchases.getPaymentUrlForBundle({
     *  'bundleName': 'com.soul.someProduct',
     *  'email': 'email@email.com'
     * })
     */

  }, {
    key: "getPaymentUrlForBundle",
    value: function getPaymentUrlForBundle(_ref3) {
      var bundleName = _ref3.bundleName,
          email = _ref3.email,
          backUrl = _ref3.backUrl,
          paymentSystem = _ref3.paymentSystem,
          rejectUrl = _ref3.rejectUrl,
          campaign = _ref3.campaign,
          sentType = _ref3.sentType,
          daysFromExpiredOffer = _ref3.daysFromExpiredOffer,
          mjTemplateId = _ref3.mjTemplateId;
      return this.api.post("purchases/order/".concat(paymentSystem || 'cardpay', "/"), _objectSpread({
        bundleName: bundleName,
        apiKey: this.apiKey
      }, email && {
        email: email
      }, backUrl && {
        backUrl: backUrl
      }, rejectUrl && {
        rejectUrl: rejectUrl
      }, campaign && {
        campaign: campaign
      }, sentType && {
        sentType: sentType
      }, daysFromExpiredOffer && {
        daysFromExpiredOffer: daysFromExpiredOffer
      }, mjTemplateId && {
        mjTemplateId: mjTemplateId
      })); // IMPORTANT trailing slash is required!
    }
  }, {
    key: "cancelMembership",
    value: function cancelMembership() {
      var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cardpay';
      var productType = arguments.length > 1 ? arguments[1] : undefined;
      return this.api.post("purchases/order/".concat(store, "/cancel/"), {
        product_type: productType
      });
    }
    /**
     * Get list of bundles by name
     * @param {array} bundleNames
     * @param {string} promocode
     * @param {array} paymentSystems
     * @return {Promise}
     * @soulsdk soul.purchases.getBundles()
     * @example soul.purchases.getBundles(["bundle.name"])
     */

  }, {
    key: "getBundles",
    value: function getBundles(bundleNames, promocode) {
      var paymentSystems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["cardpay"];
      return this.api.get("purchases/bundles/?name=".concat(bundleNames.join(','), "&store=").concat(paymentSystems.join(',')).concat(promocode ? "&promocode=".concat(promocode) : '', "&apiKey=").concat(this.apiKey));
    }
    /**
     * Purchase bundle
     * @param {string} bundle
     * @param {string} promocode
     * @param {string} store
     * @param {string} successUrl
     * @param {string} declineUrl
     * @param {string} returnUrl
     * @param {string} campaign
     * @param {string} sentType
     * @param {string} mjTemplateId
     * @param {string} daysFromExpiredOffer
     * @return {Promise}
     * @soulsdk soul.purchases.purchaseBundle()
     * @example soul.purchases.purchaseBundle({ bundle: 'bundle_name' })
     */

  }, {
    key: "purchaseBundle",
    value: function purchaseBundle(_ref4) {
      var bundle = _ref4.bundle,
          promocode = _ref4.promocode,
          _ref4$store = _ref4.store,
          store = _ref4$store === void 0 ? "cardpay" : _ref4$store,
          success_url = _ref4.successUrl,
          decline_url = _ref4.declineUrl,
          return_url = _ref4.returnUrl,
          return_url_fail = _ref4.returnUrlFail,
          campaign = _ref4.campaign,
          sent_type = _ref4.sentType,
          mj_template_id = _ref4.mjTemplateId,
          days_from_expired_offer = _ref4.daysFromExpiredOffer;
      return this.api.post("purchases/order/".concat(store, "/request/"), _objectSpread({
        bundle: bundle
      }, promocode && {
        promocode: promocode
      }, success_url && {
        success_url: success_url
      }, decline_url && {
        decline_url: decline_url
      }, return_url && {
        return_url: return_url
      }, return_url_fail && {
        return_url_fail: return_url_fail
      }, campaign && {
        campaign: campaign
      }, sent_type && {
        sent_type: sent_type
      }, mj_template_id && {
        mj_template_id: mj_template_id
      }, days_from_expired_offer !== undefined && {
        days_from_expired_offer: days_from_expired_offer
      }));
    }
    /**
     * Get list of received gifts
     * @param {function} [callback]
     * @return {Promise}
     * @soulsdk soul.purchases.getReceivedGifts
     * @example soul.purchases.getReceivedGifts()
     */

  }, {
    key: "getReceivedGifts",
    value: function getReceivedGifts(callback) {
      return this.api.get('gifts/received', callback);
    }
    /**
     * Patch gift answer
     * @param {Object} params
     * @param {string} id
     * @param {string} answer
     * @return {Promise}
     * @soulsdk soul.purchases.updateGiftAnswer
     * @example soul.purchases.updateGiftAnswer({ id: 1, answer: 'lips' })
     */

  }, {
    key: "updateGiftAnswer",
    value: function updateGiftAnswer(_ref5) {
      var id = _ref5.id,
          answer = _ref5.answer;
      return this.api.patch("gifts/received/".concat(id), {
        answer: answer
      });
    }
    /**
    * Create apple pay session
    * @param {Object} params
    * @param {string} params.validationURL
    * @param {string} params.bundle
    * @param {string} params.backUrl
    * @return {Promise}
    * @soulsdk soul.purchases.createApplePaySession
    * @example soul.purchases.createApplePaySession({
    *   'validationURL': 'https://apple-pay-gateway.apple.com/paymentservices/startSession',
    *   'bundle': 'pure-web.weekly.cardpay.ru',
    *   'backUrl': '/'
    * })
    */

  }, {
    key: "createApplePaySession",
    value: function createApplePaySession(_ref6) {
      var validationURL = _ref6.validationURL,
          bundle = _ref6.bundle,
          backUrl = _ref6.backUrl;
      return this.api.post('purchases/order/applepay/session', {
        validationURL: validationURL,
        bundle: bundle,
        backUrl: backUrl
      });
    }
    /**
    * Process a purchase in cardpay for apple pay
    * @param {string} data
    * @param {string} key
    * @return {Promise}
    * @soulsdk soul.purchases.applePayPurchase
    * @example soul.purchases.applePayPurchase({
    *   'data': '7bJRKoM56OXfYA/PiuGoqsDxq5uG+InEsXJUhei6ZvOQML+…',
    *   'key': 'eyJidW5kbGVfaWQiOiI1ZDVkMTBjYWY2MDY0MDc5MDk2NjM1NGMiLCJzdG9yZV9jb25maWdfaWQiO'
    * })
    */

  }, {
    key: "applePayPurchase",
    value: function applePayPurchase(data, key) {
      return this.api.post('purchases/order/applepay/data', {
        data: data,
        key: key
      });
    }
    /**
    * Spend chips for save random chat
    * @param {Object} params
    * @param {string} params.toUser
    * @return {Promise}
    * @soulsdk soul.purchases.saveRandomChat
    * @example soul.purchases.saveRandomChat({
    *   toUser: "65s6d5f4ge6r1erg",
    * })
    *
    */

  }, {
    key: "saveRandomChat",
    value: function saveRandomChat(_ref7) {
      var toUser = _ref7.toUser;
      return this.api.post('purchases/save-random-chat/', {
        toUser: toUser,
        consumptionId: uuid().toString()
      });
    }
    /**
    * Get Stripe Embedded form client secret
    * @param {Object} params
    * @param {string} params.bundle
    * @param {string} params.return_url
    * @param {string} params.email
    * @param {string} params.lang_code 
    * @param {string} params.app_flyer_link 
    * @param {string} params.payment_request_host 
    * @return {Promise}
    * @soulsdk soul.purchases.getStripeEmbedded
    * @example soul.purchases.getStripeEmbedded({
    *   "bundle": "stripe_week",
    *   "return_url": "https://url.de",
    *   "email": "test@email.com",
    *   "lang_code": "en",
    *   "app_flyer_link": "https://appflyer.de/?deep_link_sub1=06a9f310-6c7b-4e9e-83e5-133a7db89a4c",
    * })
    *
    */

  }, {
    key: "getStripeEmbedded",
    value: function getStripeEmbedded(_ref8) {
      var bundle = _ref8.bundle,
          return_url = _ref8.return_url,
          email = _ref8.email,
          _ref8$lang_code = _ref8.lang_code,
          lang_code = _ref8$lang_code === void 0 ? 'en' : _ref8$lang_code,
          app_flyer_link = _ref8.app_flyer_link,
          payment_request_host = _ref8.payment_request_host;
      return this.api.post("purchases/funnel/order/stripe/request/embedded/?apiKey=".concat(this.apiKey), {
        bundle: bundle,
        return_url: return_url,
        email: email,
        lang_code: lang_code,
        app_flyer_link: app_flyer_link,
        payment_request_host: payment_request_host
      });
    }
    /**
    * Get stripe session status
    * @param {string} session_id
    * @return {Promise}
    * @soulsdk soul.purchases.getStripeSessionStatus
    * @example soul.purchases.getStripeSessionStatus("65s6d5f4ge6r1erg");
    */

  }, {
    key: "getStripeSessionStatus",
    value: function getStripeSessionStatus(session_id) {
      return this.api.post("purchases/funnel/order/stripe/session/status/?apiKey=".concat(this.apiKey), {
        session_id: session_id
      });
    }
    /**
     * Obtain funnel user subscription
     * @param {string} funnel_user_id
     * @return {Promise}
     * @soulsdk soul.purchases.obtainFunnelSubscription
     * @example soul.purchases.obtainFunnelSubscription("65s6d5f4ge6r1erg");
     */

  }, {
    key: "obtainFunnelSubscription",
    value: function obtainFunnelSubscription(funnel_user_id) {
      return this.api.post('purchases/obtain-from-funnel/', {
        funnel_user_id: funnel_user_id
      });
    }
  }]);

  return Purchases;
}(SoulModule);

module.exports = Purchases;